const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70.584 51.148 c -6.331 0 -11.947 3.06 -15.493 7.763 l -17.039 -8.513 c 0.498 -1.716 0.779 -3.524 0.779 -5.399 c 0 -1.875 -0.281 -3.682 -0.779 -5.398 l 17.039 -8.513 c 3.547 4.703 9.162 7.762 15.493 7.762 C 81.29 38.852 90 30.142 90 19.436 C 90 8.73 81.29 0.02 70.584 0.02 S 51.168 8.73 51.168 19.436 c 0 1.875 0.281 3.682 0.779 5.399 l -17.038 8.512 c -3.547 -4.703 -9.162 -7.763 -15.493 -7.763 C 8.71 25.584 0 34.294 0 45 s 8.71 19.416 19.416 19.416 c 6.331 0 11.946 -3.06 15.493 -7.763 l 17.038 8.513 c -0.498 1.716 -0.779 3.524 -0.779 5.399 c 0 10.705 8.71 19.415 19.416 19.415 S 90 81.27 90 70.564 C 90 59.858 81.29 51.148 70.584 51.148 z M 70.584 7.02 C 77.431 7.02 83 12.59 83 19.436 s -5.569 12.416 -12.416 12.416 s -12.416 -5.569 -12.416 -12.416 S 63.737 7.02 70.584 7.02 z M 19.416 57.416 C 12.57 57.416 7 51.847 7 45 s 5.57 -12.416 12.416 -12.416 S 31.832 38.153 31.832 45 S 26.262 57.416 19.416 57.416 z M 70.584 82.979 c -6.847 0 -12.416 -5.569 -12.416 -12.415 c 0 -6.847 5.569 -12.416 12.416 -12.416 S 83 63.718 83 70.564 C 83 77.41 77.431 82.979 70.584 82.979 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(29,29,27)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.ddf178bc2b3ad52bc339932104bd325c.svg";
export { ForwardRef as ReactComponent };